import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import { Button, Card, Modal } from "@ui-kitten/components";
import { useState, useEffect } from "react";
import { StyleSheet, Text, TouchableOpacity, View, Linking, Image, Dimensions } from "react-native";
import { Icon } from "react-native-eva-icons";
import { WebView } from "react-native-web-webview";
import { MaterialIcons } from "@expo/vector-icons";
import {APIadminsURL} from "@env";
import { useNavigate, useParams,useLocation } from "react-router-native";
import LoadingComp from "../../../components/loading";

function DocListItem({mykey=1, name, url, type, date, size, compact, width = "100%", idDoc = 0 }) {
  const navigate = useNavigate();
  if (size) {
    size = formatBytes(size);
  }
  Image.getSize(url, (width, height) => {
    setPicDim({ width, height });
  });
  function trackdocFun(params) {
    if (idDoc) {
      AsyncStorage.getItem("token").then((res) => {
        let data = { doc_id: idDoc };
        if (res !== null) {
          axios
            .post(`${APIadminsURL}/public/api/trackdoc`, data, {
              headers: { Authorization: `Bearer ${res}` },
            })
            .then((res) => {
            })
            .catch((res) => {
              //navigate("/login");
            });
        }
      });

      //alert(idDoc);
    }
  }
  const [Myurl, setMyUrl] = useState(null);
  const [MyError, setMyError] = useState('');
  const [visible, setVisible] = useState(false);
  const [imgvisible, setImgVisible] = useState(false);
  const [picDim, setPicDim] = useState({ width: 0, height: 0 });
  const screenwidth = Dimensions.get("window").width;
  const screenheight = Dimensions.get("window").height;

  const ismobile = screenwidth < 768;
  //"https://view.officeapps.live.com/op/embed.aspx?wdPrint=0&src=" + url
  //https://www.clickdimensions.com/links/TestPDFfile.pdf
  //https://calibre-ebook.com/downloads/demos/demo.docx
  const handleVisible = (state) => {
    if (type === "pdf") {
      async function fetchData(url) {

        const token = localStorage.getItem('token');
        // Create an array to store the promises
        axios({
            url: url.replace('app/', ''),
            method: 'GET',
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
            .then((response) => {
              const thisurl = URL.createObjectURL(response.data);
              setMyUrl(thisurl);
              setMyError(null);

            })
            .catch((error) => {
              console.log(error);
              setMyError('Error when getting the file:'+error.message);

              // Handle the error here
            })
        

        // Wait for all promises to resolve

        // Update the state with the transformed data
        
      }

      fetchData(url);
      //setMyUrl('test.pdf');
      setVisible(state);
    } else if (type === "docx") {
      const token = localStorage.getItem('token');
      async function fetchData(documentUrl, token) {
        // Create an array to store the promises
        axios({
          url: documentUrl,
          method: "GET",
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            const url2 = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url2;
            link.setAttribute('download', 'document.docx');
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url2);
         
          })
          .catch((error) => {
            console.log(error);
            // Handle the error here
          });

        // Wait for all promises to resolve

        // Update the state with the transformed data
      }

      fetchData(url, token);

    } else {
      async function fetchData(url) {

              const token = localStorage.getItem('token');
              // Create an array to store the promises
              axios({
                  url: url.replace('app/', ''),
                  method: 'GET',
                  responseType: 'arraybuffer',
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                  .then((response) => {
                    const thisurl = `data:${response.headers['content-type']};base64,${Buffer.from(
                      response.data,
                      'binary'
                    ).toString('base64')}`;
                    setMyUrl(thisurl);
                    setMyError(null);
                  })
                  .catch((error) => {
                    setMyError('Error when getting the file:'+error.message);

                    console.log(error);
                    // Handle the error here
                  })
              
      
              // Wait for all promises to resolve
      
              // Update the state with the transformed data
              
            }
      
            fetchData(url);
      setImgVisible(state);
    }
  };
  const downloadfile = () => {
    if (url) {

      if(type=='pdf'){
        window.open(`/#/DocumentDisplay?url=${url}&type=pdf`, "_blank");
      }else{
        window.open(`/#/DocumentDisplay?url=${url}&type=image`, "_blank");
      }
      
      
    } else {
      console.log("document has no path url");
    }
  };
  return (
    <>
      <TouchableOpacity
      key={mykey}
        onPress={() => {
          handleVisible(true);
          trackdocFun();
        }}
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginVertical: 5,
          paddingHorizontal: 15,
          //width,
          justifyContent: "space-between",
        }}>
        <View style={{ flexDirection: "row", alignItems: "center", flexShrink: 1 }}>
          <Icon
            name={type === "pdf" ? "file-text-outline" : "image-outline"}
            width={25}
            height={25}
            fill="#8DC641"
          />

          <Text
            style={{
              fontFamily: "Roboto_400Regular",
              marginLeft: 10,
              flexShrink: 1,
              fontSize: 16,
            }}>
            {name}
          </Text>
        </View>
        {!compact && (
          <Text
            style={{
              fontFamily: "Roboto_300Light",
              textAlign: "right",
              color: "gray",
              fontSize: 12,
            }}>
            {!compact && size == 0 ? "" : size} {date}
          </Text>
        )}
      </TouchableOpacity>
      <Modal
        style={{ width: ismobile ? "90%" : 700, maxWidth: ismobile ? "100%" : 800, height: "auto" }}
        visible={visible}
        backdropStyle={styles.backdrop}
        onBackdropPress={() => handleVisible(false)}>
        <Card
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: ismobile ? "none" : "fixed",
            left: "50%",
            transform: "translate(-50%,0)",
            top: "2%",
          }}>
         
          {!Myurl ? (!MyError ? <View style={{width: ismobile ? "100%" : 700, height: screenheight - 120 }}><LoadingComp /></View> :<View style={{width: ismobile ? "100%" : 700, height: screenheight - 120 }}>{MyError}</View> ) : (
    <WebView
    style={{ width: ismobile ? "100%" : 700, height: screenheight - 120 }}
    source={{
      uri: ismobile ? "https://docs.google.com/viewer?embedded=true&url=" + Myurl : Myurl,
    }}
  />
  )}
          <View style={{ margin: 5, flexDirection: "row", justifyContent: "space-around" }}>
            <MaterialIcons
              style={{ backgroundColor: "rgb(141, 198, 65)", borderRadius: 5 }}
              onPress={() => {
                downloadfile();
              }}
              name="fullscreen"
              size={48}
              color="white"
            />
            <Button
              status="success"
              style={{ backgroundColor: "#969696", borderColor: "#969696" }}
              onPress={() => {
                handleVisible(false);
              }}>
              OK
            </Button>
          </View>
        </Card>
      </Modal>
      {/**modal to display image */}
      <Modal
        style={{ width: ismobile ? "100%" : 700, maxWidth: 900, height: screenheight }}
        visible={imgvisible}
        backdropStyle={styles.backdrop}
        onBackdropPress={() => handleVisible(false)}>
        <Card
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: "fixed",
            left: "50%",
            transform: "translate(-50%,-50%)",
            top: "50%",
          }}>
       {!Myurl ? (!MyError ? <View style={{width: ismobile ? "100%" : 700, height: screenheight - 120 }}><LoadingComp /></View> :<View style={{width: ismobile ? "100%" : 700, height: screenheight - 120 }}>{MyError}</View> ) : (
    <img
      style={{
        maxWidth: ismobile ? screenwidth - 20 : screenwidth * 0.6,
        maxHeight: screenheight - 120,
        resizeMode: "center",
      }}
      src={Myurl}
      alt="Document"
    />
  )}
   
           
          <View
            style={{
              marginTop: 20,
              margin: 5,
              flexDirection: "row",
              justifyContent: "space-around",
            }}>
            <MaterialIcons
              style={{ backgroundColor: "rgb(141, 198, 65)", borderRadius: 5 }}
              onPress={() => {
                downloadfile();
              }}
              name="fullscreen"
              size={48}
              color="white"
            />
            <Button
              status="success"
              style={{ backgroundColor: "#969696", borderColor: "#969696" }}
              onPress={() => {
                handleVisible(false);
              }}>
              OK
            </Button>
          </View>
        </Card>
      </Modal>
    </>
  );
}
const styles = StyleSheet.create({
  backdrop: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
});
export default DocListItem;
function formatBytes(a, b = 2) {
  if (!+a) return "0 Bytes";
  const c = b < 0 ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1024));
  return `${parseFloat((a / Math.pow(1024, d)).toFixed(c))} ${
    ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
  }`;
}
